<template>
  <div
    class="spinner"
    :class="{ 'spinner--full': isFull }"
  >
    <div class="spinner__wrap">
      <div class="spinner__cube--1 spinner__cube" />
      <div class="spinner__cube--2 spinner__cube" />
      <div class="spinner__cube--4 spinner__cube" />
      <div class="spinner__cube--3 spinner__cube" />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      isFull: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "../../styles/shared/shared";

  $spinner-size: 50px;
  $spinner-size-lg: 100px;
  .spinner {
    $this: &;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: $z-spinner;
    &--full {
      position: fixed;
      background: rgba($black, .3);
      #{$this}__wrap {
        width: $spinner-size-lg;
        height: $spinner-size-lg;
      }
    }
    &__wrap {
      width: $spinner-size;
      height: $spinner-size;
      margin: $spinner-size auto;
      position: relative;
      transform: rotateZ(45deg);
    }
    &__cube {
      float: left;
      width: 50%;
      height: 50%;
      position: relative;
      transform: scale(1.1);
    }

    &__cube:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $tangerine;
      animation: cube-fold 2.4s infinite linear both;
      transform-origin: 100% 100%;
      perspective: ($spinner-size * 3.5);
    }

    &__cube--2 {
      transform: scale(1.1) rotateZ(90deg);
    }

    &__cube--3 {
      transform: scale(1.1) rotateZ(180deg);
    }

    &__cube--4 {
      transform: scale(1.1) rotateZ(270deg);
    }

    &__cube--2:before {
      animation-delay: 0.3s;
    }

    &__cube--3:before {
      animation-delay: 0.6s;
    }

    &__cube--4:before {
      animation-delay: 0.9s;
    }
  }

  @keyframes cube-fold {
    0%, 10% {
      transform: rotateX(-180deg);
      opacity: 0;
    }
    25%, 75% {
      transform: rotateX(0deg);
      opacity: 1;
    }
    90%, 100% {
      transform: rotateY(180deg);
      opacity: 0;
    }
  }
</style>
